import { Trans } from '@lingui/macro'
import React from 'react'
import { MessagePage } from 'webbook-airways'

export default function ErrorBoundary(props) {
  return <ErrorBoundaryComponent {...props} />
}

class ErrorBoundaryComponent extends React.Component {
  state = { error: null, errorInfo: null }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error: true }
  }
  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo })
    if (process.env.NODE_ENV !== 'development') {
      console.log({
        variables: {
          error_log: {
            name: 'DANGER', // Error name
            message: error.toString(), // Error message
            trace: errorInfo.componentStack, // Error trace
            location: window.location.href,
            user_agent: window.navigator.userAgent,
            platform: window.navigator.platform
          }
        }
      })
    }
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <MessagePage fullHeight title={<Trans>An error occured</Trans>}>
          <Trans>Something went wrong</Trans>
        </MessagePage>
      )
    }
    return this.props.children
  }
}
